import AlexB from '@/images/community/AlexB.webp';
import Colum from '@/images/community/Colum.webp';
import Giorgio from '@/images/community/GiorgioBoa.webp';
import Hux from '@/images/community/Hux.webp';
import Jack from '@/images/community/JackHerrington.webp';
import Ken from '@/images/community/KenWheeler.webp';
import MikeG from '@/images/community/MikeG.webp';
import RonR from '@/images/community/RonR.webp';
import Theo from '@/images/community/Theo.webp';
import Generic from '@/images/community/z-logo.webp';

export const Testimonials = [
  {
    name: 'Mike Grabowski',
    content:
      'Thanks to Zephyr we can confidently take Module Federation apps to production, on our own cloud and focus on features and leave all the infrastructure setup to them.',
    avatar: MikeG,
    role: 'CTO & Co-Founder',
    company: 'Callstack',
    socialLinks: [
      {
        link: 'https://x.com/grabbou',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/mikede30',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Jack Herrington',
    content:
      "Zephyr brings the promise of Module Federation to life. Immediate deploys and rollbacks. Version control. Native and Web support. It's all there.",
    avatar: Jack,
    role: 'Founder',
    company: 'Blue Collar Coder',
    socialLinks: [
      {
        link: 'https://x.com/jherr',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/jherr',
        platform: 'LinkedIn',
      },
      {
        link: 'https://www.youtube.com/@jherr',
        platform: 'YouTube',
      },
    ],
  },
  {
    name: 'Xuan Huang (Huxpro)',
    content:
      "Let's make Micro Frontend and Module Federation a first-class citizen of the future of frontend development.",
    avatar: Hux,
    role: 'Software Architect',
    company: 'ByteDance',
    socialLinks: [
      {
        link: 'https://x.com/Huxpro',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/huxpro',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Alex Bennett',
    content:
      'As our organization leans more into AI generated UI, I see Zephyr as the key piece to make our experimentation safe, reliable, and versioned so we can easily understand impact.',
    avatar: AlexB,
    role: 'Sr. Principal Architect',
    company: 'Accuris',
    socialLinks: [
      {
        link: 'https://x.com/alexUX_UI',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/alexuxui',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Ken Wheeler',
    content: 'Zephyr Cloud is a no-brainer if you have a giant app',
    avatar: Ken,
    role: 'Software Engineer',
    company: 'Citadel Securities',
    socialLinks: [
      {
        link: 'https://x.com/ken_wheeler',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/kennywheeler',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Ron R.',
    content:
      'Module Federation is amazing, but for it to really shine you need a way to glue it to the daily development process and CI. Zephyr is that glue. Expect Zephyr to speed up your dev cycle by 10x if not more.',
    avatar: RonR,
    role: 'Software Engineer',
    company: 'Snap',
    socialLinks: [
      {
        link: 'https://x.com/ronos_r',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/ronrosenshain',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Giorgio Boa',
    content:
      'With Zephyr Cloud you can seamlessly combine your micro frontends to unprecedented levels of performance. Join the revolution with a platform that will transform your development workflow.',
    avatar: Giorgio,
    role: 'Sr. Software Engineer',
    company: 'Qarik',
    socialLinks: [
      {
        link: 'https://x.com/giorgio_boa',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/giorgio-boa',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Zhang Lei',
    content:
      "Going from idea to global scale production couldn't be easier than with Rspack and Zephhr Cloud. Sub second builds and sub second and versioned deploys combined with instant rollbacks help avoid Sev1 downtime.",
    avatar: Generic,
    role: 'Web Infra manager',
    company: 'Web Infra',
    socialLinks: [
      {
        link: 'https://x.com/zoolsher',
        platform: 'X',
      },
    ],
  },
  {
    name: 'Colum Ferry',
    content:
      'Zephyr Cloud is the Micro Frontend orchestration tool you never knew you needed. What they have built will change deployments for the better. Think of the disruption k8s caused. Zephyr Cloud will do the same for the Micro Frontend world.',
    avatar: Colum,
    role: 'Sr. Software Engineer',
    company: 'Nx',
    socialLinks: [
      {
        link: 'https://x.com/FerryColum',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/colum-ferry-3a36a9169',
        platform: 'LinkedIn',
      },
    ],
  },
  {
    name: 'Theo Browne',
    content: 'Big teams deserve good DX too',
    avatar: Theo,
    role: 'Founder & CEO',
    company: 'Ping Labs',
    socialLinks: [
      {
        link: 'https://x.com/theo',
        platform: 'X',
      },
      {
        link: 'https://www.linkedin.com/in/t3gg',
        platform: 'LinkedIn',
      },
      {
        link: 'https://www.youtube.com/@t3dotgg',
        platform: 'YouTube',
      },
      {
        link: 'https://www.twitch.tv/theo',
        platform: 'Twitch',
      },
    ],
  },
];
